import { InputLabel, Stack, Box } from '@mui/material';
import Label from './Label';

export default function KeyValueLabelDisplay({ title, data, variant = 'ghost', color = 'info' }) {
  return (
    <Stack>
      <InputLabel shrink>{title}</InputLabel>
      <Box>
        <Label variant={variant} color={color}>
          {data}
        </Label>
      </Box>
    </Stack>
  );
}
